<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<loading :active="loading">
					<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
				</loading>
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4  class="modal-title">Configuración cuenta</h4>
				</div>
				<div class="modal-body">
					<div class="sttabs tabs-style-iconbox">
						<nav>
							<ul>
								<li>
									<a href="#section-general" class="sticon fa fa-edit">
										<span>General</span>
									</a>
								</li>
								<li>
									<a href="#section-logo" class="sticon fa fa-file-image-o">
										<span>Logo</span>
									</a>
								</li>
								<li>
									<a href="#section-cover" class="sticon fa fa-picture-o">
										<span>Cover</span>
									</a>
								</li>
								<li>
									<a href="#section-icon" class="sticon fa fa-picture-o">
										<span>Icono</span>
									</a>
								</li>
								<li>
									<a href="#section-place" class="sticon fa fa-map-marker">
										<span>Localización</span>
									</a>
								</li>
							</ul>
						</nav>
						<div class="content-wrap">
							<section id="section-general">
								<form @submit="validate">
									<div class="row">
										<div class="col-md-6">
											<div class="form-group" :class="{ 'has-error' : errors.has('name') }">
												<label class="control-label">Nombre</label>
												<input
													type="text"
													class="form-control"
													name="name"
													v-validate="'required'"
													data-vv-as="Nombre"
													v-model="general.name"
												/>
												<small v-show="errors.has('name')" class="form-text text-danger">
													{{ errors.first('name') }}
												</small>
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label class="control-label">Empresa</label>
												<input
													type="text"
													class="form-control"
													name="company"
													v-model="general.company"
												/>
											</div>
										</div>
										<div class="col-md-12">
											<div class="form-group">
												<label class="control-label">Número identificación</label>
												<input
													type="text"
													class="form-control"
													v-model="general.identification_number"/>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-12">
											<div class="form-group">
												<label class="control-label">Descripción</label>
												<textarea
													class="form-control"
													v-model="general.description">
												</textarea>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-6">
											<div class="form-group" :class="{ 'has-error' : errors.has('email_address') }">
												<label class="control-label">E-mail</label>
												<input
													type="email"
													class="form-control"
													name="email_address"
													v-validate="'required|email'"
													data-vv-as="E-mail"
													v-model="general.email_address"
												/>
												<small v-show="errors.has('email_address')" class="form-text text-danger">
													{{ errors.first('email_address') }}
												</small>
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label class="control-label">E-mail de contacto</label>
												<input
													type="email"
													class="form-control"
													v-model="general.contact_email"
												/>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-6">
											<div class="form-group">
												<label class="control-label">Móvil 1</label>
												<input
													type="text"
													class="form-control"
													v-model="general.mobile"/>
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label class="control-label">Móvil 2</label>
												<input
													type="text"
													class="form-control"
													v-model="general.mobile_2"/>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-6">
											<div class="form-group">
												<label class="control-label">Teléfono</label>
												<input
													type="text"
													class="form-control"
													v-model="general.phone"/>
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label class="control-label">Teléfono 2</label>
												<input
													type="text"
													class="form-control"
													v-model="general.phone_2"/>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-6">
											<div class="form-group">
												<label class="control-label">Fax</label>
												<input
													type="text"
													class="form-control"
													v-model="general.fax"
												/>
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label class="control-label">Marca</label>
												<input
													type="text"
													class="form-control"
													v-model="general.brand"/>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-6">
											<div class="form-group">
												<label class="control-label">Slogan</label>
												<input
													type="text"
													class="form-control"
													v-model="general.slogan"/>
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label class="control-label">Alias</label>
												<input
													type="text"
													class="form-control"
													v-model="general.alias"/>
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label class="control-label">Color corporativo</label>
												<input
													type="color"
													class="form-control"
													v-model="general.brand_color"/>
											</div>
										</div>
									</div>
								</form>
							</section>
							<section id="section-logo">
								<form action="#">
									<div class="form-body">
										<template v-if="logo">
											<img :src="logo" class="img-responsive">
											<button @click="destroyLogo()" type="button" class="btn btn-danger">
												<i class="fa fa-trash" aria-hidden="true"></i>
											</button>
										</template>
										<template v-else>
											<dropzone v-if="headers"
												:id="'dropzone-logo' + new Date().getTime()"
												ref="dropzoneLogo"
												:use-font-awesome="true"
												:url="dropzoneLogo.url"
												:accepted-file-types="dropzoneLogo.accepted"
												:maxNumberOfFiles="dropzoneLogo.maxNumberOfFiles"
												v-on:vdropzone-thumbnail="dropzoneLogo.thumbnail"
												v-on:vdropzone-mounted="mountedDropzoneLogo"
												:thumbnail-height="100"
												:thumbnail-width="100"
												:headers="headers"
												v-on:vdropzone-success="dropzoneLogoSuccess">
												</dropzone>
												<p class="text-center">
													<small>Requisitos: 350px X 79px, extensión "png" o "svg"</small>
												</p>
										</template>
									</div>
								</form>
							</section>
							<section id="section-cover">
								<form action="#">
									<div class="form-body">
										<template v-if="cover">
											<img :src="cover" class="img-responsive">
											<button @click="destroyCover()" type="button" class="btn btn-danger">
												<i class="fa fa-trash" aria-hidden="true"></i>
											</button>
										</template>
										<template v-else>
											<dropzone v-if="headers"
												:id="'dropzone-cover' + new Date().getTime()"
												ref="dropzoneCover"
												:use-font-awesome="true"
												:url="dropzoneCover.url"
												:accepted-file-types="dropzoneCover.accepted"
												:maxNumberOfFiles="dropzoneCover.maxNumberOfFiles"
												v-on:vdropzone-thumbnail="dropzoneCover.thumbnail"
												v-on:vdropzone-mounted="mountedDropzoneCover"
												:thumbnail-height="100"
												:thumbnail-width="100"
												:headers="headers"
												v-on:vdropzone-success="dropzoneCoverSuccess">
												</dropzone>
												<p class="text-center">
													<small>Requisitos: 1600px X 1103px, extensión "jpg" o "svg"</small>
												</p>
										</template>
									</div>
								</form>
							</section>
							<section id="section-icon">
								<form action="#">
									<div class="form-body">
										<template v-if="icon">
											<img :src="icon" class="img-responsive">
											<button @click="destroyIcon()" type="button" class="btn btn-danger">
												<i class="fa fa-trash" aria-hidden="true"></i>
											</button>
										</template>
										<template v-else>
											<dropzone v-if="headers"
												:id="'dropzone-icon' + new Date().getTime()"
												ref="dropzoneIcon"
												:use-font-awesome="true"
												:url="dropzoneIcon.url"
												:accepted-file-types="dropzoneIcon.accepted"
												:maxNumberOfFiles="dropzoneIcon.maxNumberOfFiles"
												v-on:vdropzone-thumbnail="dropzoneIcon.thumbnail"
												v-on:vdropzone-mounted="mountedDropzoneIcon"
												:thumbnail-height="100"
												:thumbnail-width="100"
												:headers="headers"
												v-on:vdropzone-success="dropzoneIconSuccess">
												</dropzone>
												<p class="text-center">
													<small>Requisitos: 350px X 79px, extensión "png" o "svg"</small>
												</p>
										</template>
									</div>
								</form>
							</section>
							<section id="section-place">
								<form action="#">
									<div class="form-body">
										<div class="row">
											<div class="col-md-12">
												<div class="form-group">
													<label>Buscar</label>
													<input ref="inputAutocompleteEdit" type="search" id="input-autocomplete-edit" class="form-control" placeholder="Buscar...">
												</div>
											</div>
										</div>
										<div v-if="general.place" class="row">
											<div class="col-md-12">
												<div class="form-group">
													<label>País</label>
													<input v-model="general.place.country" type="text" class="form-control" placeholder="País...">
												</div>
											</div>
											<div class="col-md-12">
												<div class="form-group">
													<label>Comunidad autónoma</label>
													<input v-model="general.place.administrative_area_level_1" type="text" class="form-control" placeholder="Comunidad autónoma...">
												</div>
											</div>
											<div class="col-md-12">
												<div class="form-group">
													<label>Provincia</label>
													<input v-model="general.place.administrative_area_level_2" type="text" class="form-control" placeholder="Provincia...">
												</div>
											</div>
											<div class="col-md-12">
												<div class="form-group">
													<label>Ciudad</label>
													<input v-model="general.place.locality" type="text" class="form-control" placeholder="Ciudad...">
												</div>
											</div>
											<div class="col-md-12">
												<div class="form-group">
													<label>Dirección</label>
													<input v-model="general.place.formatted_address" type="text" class="form-control" placeholder="Dirección...">
												</div>
											</div>
											<div class="col-md-12">
												<div class="form-group">
													<label>Nombre</label>
													<input v-model="general.place.name" type="text" class="form-control" placeholder="Nombre...">
												</div>
											</div>
											<div class="col-md-6">
												<div class="form-group">
													<label>Número</label>
													<input v-model="general.place.street_number" type="text" class="form-control" placeholder="Número...">
												</div>
											</div>
											<div class="col-md-6">
												<div class="form-group">
													<label>Barrio</label>
													<input v-model="general.place.sublocality_level_1" type="text" class="form-control" placeholder="Barrio...">
												</div>
											</div>
											<div class="col-md-12">
												<div class="form-group">
													<label>Código postal</label>
													<input v-model="general.place.postal_code" type="text" class="form-control" placeholder="Código postal...">
												</div>
											</div>

											<div class="col-md-6">
												<div class="form-group">
													<label>Latitud</label>
													<input v-model="general.place.lat" type="text" class="form-control" placeholder="Latitud...">
												</div>
											</div>
											<div class="col-md-6">
												<div class="form-group">
													<label>Longitud</label>
													<input v-model="general.place.lng" type="text" class="form-control" placeholder="Longitud...">
												</div>
											</div>
										</div>
									</div>
								</form>
							</section>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-success" @click="validate">Guardar</button>
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Dropzone from 'vue2-dropzone'
	import swal from 'sweetalert2'
	import VueElementLoading from 'vue-element-loading'
	export default {
		props: ['user', 'isAuth'],
		components: {
			'loading': VueElementLoading,
			'dropzone': Dropzone,
		},
		data () {
			return {
				modal: {
					selector: 'modal-setting-account'
				},
				dropzoneLogo: {
					url: process.env.ROOT + '/api/' + this.$lang.getLang() + '/admin/platforms/' + this.$platform.id + '/logo',
					accepted: "image/png,.svg",
					maxNumberOfFiles: 1,
					thumbnail: function(file) {
						var minImageWidth = 350
						var minImageHeight = 79
						if (file.width != minImageWidth && file.height != minImageHeight) {
							file.rejectDimensions()
						} else {
							file.acceptDimensions()
						}
					},
				},

				dropzoneCover: {
					url: process.env.ROOT + '/api/' + this.$lang.getLang() + '/admin/platforms/' + this.$platform.id + '/cover',
					accepted: "image/jpeg,image/png",
					maxNumberOfFiles: 1,
					thumbnail: function(file) {
						var minImageWidth = 1600
						var minImageHeight = 1103
						if (file.width != minImageWidth && file.height != minImageHeight) {
							file.rejectDimensions()
						} else {
							file.acceptDimensions()
						}
					},
				},

				dropzoneIcon: {
					url: process.env.ROOT + '/api/' + this.$lang.getLang() + '/admin/platforms/' + this.$platform.id + '/icon',
					accepted: "image/png,.svg",
					maxNumberOfFiles: 1,
					thumbnail: function(file) {
						var minImageWidth = 350
						var minImageHeight = 79
						if (file.width != minImageWidth && file.height != minImageHeight) {
							file.rejectDimensions()
						} else {
							file.acceptDimensions()
						}
					},
				},

				platform: null,
				loading: false,

				general: {
					name: null,
					company: null,
					description: null,
					email_adress: null,
					contact_email: null,
					phone: null,
					phone_2: null,
					fax: null,
					mobile: null,
					mobile_2: null,
					phone: null,
					phone_2: null,
					brand: null,
					brand_color: null,
					slogan: null,
					alias: null,
					identification_number: null,

					place: null,
				},

				logo: null,
				cover: null,
				icon: null,

				headers: null,
			}
		},
		mounted() {
			this.initAutocomplete();
			this.generateHeaders();
			[].slice.call(document.querySelectorAll('.sttabs')).forEach(function(el) {
				new CBPFWTabs(el);
			})
		},
		methods: {
			mountedDropzoneLogo() {
				this.$refs.dropzoneLogo.setOption('accept', function(file, done) {
					file.acceptDimensions = done;
					file.rejectDimensions = () => { done("Los requisitos de la imagen no son válidos"); };
				})
			},
			mountedDropzoneCover() {
				this.$refs.dropzoneCover.setOption('accept', function(file, done) {
					file.acceptDimensions = done;
					file.rejectDimensions = () => { done("Los requisitos de la imagen no son válidos"); };
				})
			},
			mountedDropzoneIcon() {
				this.$refs.dropzoneIcon.setOption('accept', function(file, done) {
					file.acceptDimensions = done;
					file.rejectDimensions = () => { done("Los requisitos de la imagen no son válidos"); };
				})
			},
			open() {
				this.clearData()
				this.getPlatform()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			reload() {
				this.getPlatform()
			},
			clearData() {
				$(this.$refs.inputAutocompleteEdit).val('')
				this.general.name = null
				this.general.description = null
				this.general.email_address = null
				this.general.contact_email = null
				this.general.phone = null
				this.general.phone_2 = null
				this.general.fax = null
				this.general.mobile = null
				this.general.mobile_2 = null
				this.general.phone = null
				this.general.phone_2 = null
				this.general.brand = null
				this.general.brand_color = null
				this.general.slogan = null
				this.general.alias = null
				this.general.identification_number = null
				this.errors.clear()
			},
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.update()
					}
					return result
				})
			},
			getPlatform() {
				this.loading = true
				this.$http.get('platform')
				.then(response => {
					this.platform = response.body

					this.general.name = this.platform.name
					this.general.company = this.platform.company
					this.general.description = this.platform.description
					this.general.email_address = this.platform.email_address
					this.general.contact_email = this.platform.contact_email
					this.general.phone = this.platform.phone
					this.general.phone_2 = this.platform.phone_2
					this.general.fax = this.platform.fax
					this.general.mobile = this.platform.mobile
					this.general.mobile_2 = this.platform.mobile_2
					this.general.phone = this.platform.phone
					this.general.phone = this.platform.phone
					this.general.phone_2 = this.platform.phone_2
					this.general.brand = this.platform.brand
					this.general.brand_color = this.platform.brand_color
					this.general.slogan = this.platform.slogan
					this.general.alias = this.platform.alias
					this.general.identification_number = this.platform.identification_number

					this.general.place = {
						formatted_address: this.platform.place.formatted_address,
						name: this.platform.place.name,
						google_place_id: this.platform.place.google_place_id,
						url: this.platform.place.url,
						country: this.platform.place.country,
						country_short_name: this.platform.place.country_short_name,
						postal_code: this.platform.place.postal_code,
						administrative_area_level_1: this.platform.place.administrative_area_level_1,
						administrative_area_level_2: this.platform.place.administrative_area_level_2,
						locality: this.platform.place.locality,
						route: this.platform.place.route,
						street_number: this.platform.place.street_number,
						sublocality_level_1: this.platform.place.sublocality_level_1,
						sublocality_level_2: this.platform.place.sublocality_level_2,
						lat: this.platform.place.lat,
						lng: this.platform.place.lng,
					}

					this.logo = this.platform.logo
					this.cover = this.platform.cover
					this.icon = this.platform.icon

					this.loading = false
				}, function(error) {
					console.log(error)
				})
			},
			update() {
				this.loading = true
				this.$http.put('admin/platforms/' + this.platform.id, this.general)
				.then(response => {
					$(this.$refs.inputAutocompleteEdit).val('')
					this.reload()
					this.$platform = response.body.data
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
					this.loading = false
				})
				.catch(response => {
					console.log(response)
					this.loading = false
				})
			},
			dropzoneLogoSuccess (file, response) {
				this.logo = response
				this.$platform.logo = this.logo
			},
			dropzoneCoverSuccess (file, response) {
				this.cover = response
				this.$platform.cover = this.cover
			},
			dropzoneIconSuccess (file, response) {
				this.icon = response
				this.$platform.icon = this.icon
			},
			generateHeaders() {
				var token = this.$auth.getToken()
				var headers = {
					account: this.$platform.slug,
					Authorization: "Bearer " + token
				}
				this.headers = headers
			},
			destroyLogo() {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.get('admin/platforms/' + that.platform.id + '/logo/destroy')
							.then(response => {
								that.$platform.logo = null
								that.logo = null
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			destroyCover() {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.get('admin/platforms/' + that.platform.id + '/cover/destroy')
							.then(response => {
								that.$platform.cover = null
								that.cover = null
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			destroyIcon() {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.get('admin/platforms/' + that.platform.id + '/icon/destroy')
							.then(response => {
								that.$platform.icon = null
								that.icon = null
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			initAutocomplete() {
				var that = this
				this.autocomplete = new google.maps.places.Autocomplete(
					(that.$refs.inputAutocompleteEdit),
					{types: ['geocode']}
				);
				this.autocomplete.addListener('place_changed', function(event) {
					var place = that.autocomplete.getPlace();
					that.loadPlace(place)
				});
			},
			clearPlace() {
				this.general.place.formatted_address = null
				this.general.place.name = null
				this.general.place.google_place_id = null
				this.general.place.url = null
				this.general.place.country = null
				this.general.place.country_short_name = null
				this.general.place.postal_code = null
				this.general.place.administrative_area_level_1 = null
				this.general.place.administrative_area_level_2 = null
				this.general.place.locality = null
				this.general.place.route = null
				this.general.place.street_number = null
				this.general.place.sublocality_level_1 = null
				this.general.place.sublocality_level_2 = null
				this.general.place.lat = null
				this.general.place.lng = null
			},
			loadPlace(place) {
				this.clearPlace()

				var that = this
				if(place) {
					this.general.place.formatted_address = place.formatted_address
					this.general.place.name = place.name
					this.general.place.google_place_id = place.place_id
					this.general.place.url = place.url

					this.general.place.lat = place.geometry.location.lat()
					this.general.place.lng = place.geometry.location.lng()

					var address_components = []
					if(place.address_components) {
						place.address_components.forEach(function(element) {
							var type = element.types[0]
							var component = {
								type: type,
								value: element.long_name
							}
							address_components.push(component)
							if(type == 'country') {
								var component = {
									type: 'country_short_name',
									value: element.short_name
								}
								address_components.push(component)
							}
						})
					}
					address_components.forEach(function(element) {
						if(that.general.place[element.type] !== 'undefined') {
							that.general.place[element.type] = element.value
						}
					})
				}
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/views/Account.vue